module.exports = __webpack_public_path__ + "static/media/portfolio2014Home.d709f4b9.jpg";